import { Instagram, Music2, Youtube } from "lucide-react";
import { classNames } from "@/lib/format";

const CONFIG = {
  instagram: { label: "Instagram", icon: Instagram, style: "bg-[hsl(var(--platform-instagram)/0.15)] text-[hsl(var(--platform-instagram))]" },
  tiktok: { label: "TikTok", icon: Music2, style: "bg-[hsl(var(--platform-tiktok)/0.15)] text-[hsl(var(--platform-tiktok))]" },
  youtube: { label: "Shorts", icon: Youtube, style: "bg-[hsl(var(--platform-youtube)/0.15)] text-[hsl(var(--platform-youtube))]" },
};

export default function PlatformBadge({ platform, size = "sm" }) {
  const cfg = CONFIG[platform] || { label: platform, icon: null, style: "bg-muted text-muted-foreground" };
  const Icon = cfg.icon;
  const sizeCls = size === "xs" ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2 py-0.5";
  return (
    <span
      className={classNames(
        "inline-flex items-center gap-1 rounded-full font-medium",
        sizeCls,
        cfg.style
      )}
      data-testid={`platform-badge-${platform}`}
    >
      {Icon && <Icon className="h-3 w-3" />}
      {cfg.label}
    </span>
  );
}
